module.exports = __webpack_public_path__ + "media/src/application/media/svg/Union-cac1bade08916691cf709aa0e7f2d27f.svg";